import { render, staticRenderFns } from "./PublicOverviewPatent.vue?vue&type=template&id=17d9ad6b"
import script from "./PublicOverviewPatent.vue?vue&type=script&lang=js"
export * from "./PublicOverviewPatent.vue?vue&type=script&lang=js"
import style0 from "./PublicOverviewPatent.vue?vue&type=style&index=0&id=17d9ad6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports